const config = require("config");

(function () {
  var serviceId = "userService";

  angular
    .module("app")
    .factory(serviceId, [
      "$http", "$q", "$rootScope", "_", "mapService", "routeService", "$window", "LocationItem", "UserProvider",
      "routingProfile", "routeExceptionService", "favoriteLocationsService",  "eventTracker", "applicationSettingsService",
      function ($http, $q, $rootScope, _, mapService, routeService, $window, LocationItem, userProvider,
        routingProfile, routeExceptionService, favoriteLocationsService, eventTracker, applicationSettingsService) {
        var dataServiceUrl = config.daUrl;

        var totalMiles = 0;
        var savedRoutes = [];

        var avoidFavorsSet = [];
        var avoidFavorsSetReady = false;
        var saveRouteLimit = 1500;
        function getTotalMiles() {
          return totalMiles;
        }

        function getData() {
          // if the user is not logged in, don't get any trips
          if (userProvider.getUser().isLoggedIn !== true) {
            return;
          }

          var avoidFavorPromise = routeExceptionService.getRouteExceptionSets(false);

          avoidFavorPromise.then(resp => {
            var getGroupsPromises = [];

            _.forEach(resp.data, (set) => {
              var deferred = $q.defer();

              routeExceptionService
                .getGroupsForSet(set.SetID, true)
                .then((res) => {
                  set.groups = res.data;
                  deferred.resolve(set);
                });

              getGroupsPromises.push(deferred.promise);
            });

            $q.all(getGroupsPromises).then((res) => {
              avoidFavorsSet = res;
              avoidFavorsSetReady = true;
            });
          });

          function buildSavedRoutes(data) {
            return _.map(data, v => {
              return {
                savedId: v.Id,
                name: v.Name,
                stops: _.map(v.Stops, val => {
                  if (!val.Location.PlaceName) {
                    return new LocationItem(val.Location);
                  } else {
                    return new LocationItem(val.Location, val.Location.PlaceName);
                  }
                }),
                options: routingProfile.getPCMRouteOptionsFromDA(v.Profile)
              };
            });
          }

          var tripPromise = $http.get(`${dataServiceUrl}trips/-1?onlyMine=True&pageSize=${getSaveRouteLimit()}`);
          var routeSyncPromise = $http.get(`${dataServiceUrl}routesync/-1`);

          // TODO: investigate if the routeSyncPromise is still needed to filter dupes
          $q.all([tripPromise, routeSyncPromise]).then(results => {
            var rsIds = [];
            _.each(results[1].data, r => {
              if (r.Trip !== null && r.Trip !== undefined) {
                rsIds.push(r.Trip.Id);
              }
            });
            // filter out trips from routeSync
            results[0].data = _.filter(results[0].data, d => {
              return rsIds.indexOf(d.Id) === -1;
            });
            savedRoutes = buildSavedRoutes(results[0].data);
            if (savedRoutes && savedRoutes.length > 0) {
              const least = getLeastVersion(savedRoutes);
              window.sessionStorage.setItem("Minimum_Data_Version_Used", least.options.dataVersion);
              var userCfg = applicationSettingsService.getUserCfg(); // get user cfg
              if(userCfg && userCfg.Minimum_Data_Version_Used && userCfg.Minimum_Data_Version_Used !== "") {
                const leastVersionIndex = getLeastVersionIndex(least.options.dataVersion, userCfg.Minimum_Data_Version_Used);
                if (leastVersionIndex === 0) {
                  userCfg.Minimum_Data_Version_Used = least.options.dataVersion;
                  applicationSettingsService.updateUserCfg(userCfg);
                  eventTracker.track(eventTracker.EVENTS.LEAST_DATA_VERSION, {
                    version: least.options.dataVersion
                  });
                }
              } else {
                userCfg.Minimum_Data_Version_Used = least.options.dataVersion;
                applicationSettingsService.updateUserCfg(userCfg);
                eventTracker.track(eventTracker.EVENTS.LEAST_DATA_VERSION, {
                  version: least.options.dataVersion
                });
              }
            }            
          })
          // TODO pchen: refactor this with finally (savedRoutes outside of promise chain, etc.)
            .catch(err => {
            // NOTE: this was added to prevent the trips from not loading when /routesync request fails
              tripPromise.then(results => {
                savedRoutes = buildSavedRoutes(results.data);
              });
            })

          // pchen: does this need to be in the $q.all above?
          favoriteLocationsService.loadData();
        }

        // Init the data when this this service first gets initialized in case the user is already logged in and we haven't started listening for the UserLoaded event.
        getData();

        var upsert = function (arr, key, newval) {
          var match = _.find(arr, key);
          if (match) {
            var index = _.indexOf(arr, _.find(arr, key));
            arr.splice(index, 1, newval);
          } else {
            arr.push(newval);
          }
        };

        function getLeastVersion(versions) {
          const filterEmptyDataVersionRoutes = versions.filter(route => route.options.dataVersion && route.options.dataVersion !== "");
          const least = filterEmptyDataVersionRoutes.reduce((previous, current) => {
            const leastVersionIndex = getLeastVersionIndex(current.options.dataVersion, previous.options.dataVersion);
            if(leastVersionIndex >= 0)  {
              return leastVersionIndex === 0 ? current : previous
            } else {
              return  angular.lowercase(current.options.dataVersion) < angular.lowercase(previous.options.dataVersion) ? current : previous;
            }
          });
          return least;
        }
    
        function getLeastVersionIndex(version, version1) {
          const currentVersionNo = version.length > 5 ? angular.lowercase(version) : parseInt(version.substring(3,5));
          const previousVersionNo = version1.length > 5 ? angular.lowercase(version1) : parseInt(version1.substring(3,5));
            if((typeof (currentVersionNo) === "number") && (typeof (previousVersionNo) === "number")) {
              return currentVersionNo > previousVersionNo ? 1 : 0;
            } else {
              const versionArray =  [currentVersionNo, previousVersionNo];
              const index = versionArray.findIndex(val => typeof (val) === "number" );
              return index;
            }
        }

        function updateRoute(route) {
          var deferred = $q.defer();
          var savedRoute;

          if (!route.savedId && canSaveRoute(angular.copy(route.stops), angular.copy(route.options)) === false) {
            deferred.reject({});
            return deferred.promise;
          }

          var r = {
            Id: route.savedId,
            Name: route.name,
            Stops: _.map(_.map(route.stops, "ALKObj"), stop => {
              return {
                "Location": stop
              };
            }),
            Profile: routingProfile.getDARouteOptionsFromPCM(route.options)
          };

          // save new route.
          $http.put(`${dataServiceUrl}trips/${route.savedId}`, r).success(resp => {
            upsert(savedRoutes, {
              savedId: route.savedId
            }, angular.copy(route));
            deferred.resolve(route);
          }).error(err => {
            deferred.reject(err);
          });

          return deferred.promise;
        }

        function saveRoute(stops, options, name) {
          var deferred = $q.defer();
          var savedRoute;
          //remove routing profileId from options and set it to -1
          options.routingProfileId = -1;
          if (canSaveRoute(angular.copy(stops), angular.copy(options)) === false) {
            deferred.reject({});
            return deferred.promise;
          }

          var r = {
            Name: name,
            Stops: _.map(_.map(stops, "ALKObj"), stop => {
              return {
                "Location": stop
              };
            }),
            Profile: routingProfile.getDARouteOptionsFromPCM(options)
          };

          // save new route.
          $http.post(`${dataServiceUrl}trips`, r).success(resp => {
            savedRoute = {
              savedId: resp.Id,
              name: name,
              stops: angular.copy(stops),
              options: angular.copy(options)
            };

            savedRoutes.push(savedRoute);
            deferred.resolve(savedRoute);
          }).error(err => {
            deferred.reject(err);
          });

          return deferred.promise;
        }

        function getSavedRoute(stops, options) {
          var originalStops = _.map(stops, "ALKObj");

          // if the passed in route (stops and options) are the same as any of the current route stops/options in the saved routes, don't allow it to be saved.
          var route = _.find(savedRoutes, r => {
            var currentStops = _.map(r.stops, "ALKObj");

            return angular.equals(originalStops, currentStops) && angular.equals(options, r.options);
          });

          return route;
        }

        function canSaveRoute(stops, options) {
          if (userProvider.getUser().isLoggedIn === false) {
            return false;
          }

          // if this route already exists in the list of saved routes, don't allow it to be saved.
          // if this route does not exist in the list of saved routes, let the user save it.
          if (getSavedRoute(stops, options)) {
            return false;
          }

          return true;
        }

        function getSavedRoutes() {
          return savedRoutes;
        }

        function deleteSavedRoute(r) {
          $http.delete(`${dataServiceUrl}trips/${r.savedId}`).success(() => {
            _.remove(savedRoutes, r);
          });
        }

        function getAvoidFavorsSets() {
          return avoidFavorsSet;
        }

        function hasAvoidFavorsSet() {
          return (getAvoidFavorsSets() !== null && getAvoidFavorsSets() !== undefined) && (getAvoidFavorsSets().length > 0);
        }

        function isAvoidFavorsSetReady() {
          return avoidFavorsSetReady;
        }
        function getSaveRouteLimit() {
          return saveRouteLimit;
        }
        function getSavedTrip(tripId) {
          var deferred = $q.defer();
          // get saved new route along with randomly generated routingProfileId
          $http.get(`${dataServiceUrl}trips/${tripId}`).success(resp => {
            deferred.resolve(resp);
          }).error(err => {
            deferred.reject(err);
          });

          return deferred.promise;

        }
        $rootScope.$on("UserLoggedIn", (event, message) => { // jshint ignore:line
          getData();
        });

        // when a user logs out, clear all data back to initial values.
        $rootScope.$on("UserLoggedOut", (event, message) => { // jshint ignore:line
          totalMiles = 0;
          savedRoutes = [];
          favoriteLocationsService.clearData();
        });

        return {
          getTotalMiles: getTotalMiles,
          saveRoute: saveRoute,
          updateRoute: updateRoute,
          canSaveRoute: canSaveRoute,
          getSavedRoutes: getSavedRoutes,
          deleteSavedRoute: deleteSavedRoute,
          getAvoidFavorsSets: getAvoidFavorsSets,
          hasAvoidFavorsSet: hasAvoidFavorsSet,
          isAvoidFavorsSetReady: isAvoidFavorsSetReady,
          getSaveRouteLimit: getSaveRouteLimit,
          getSavedTrip:getSavedTrip
        };
      }
    ]);
})();



// WEBPACK FOOTER //
// ./app/account/user.service.js